export enum GAMIFICATION_TAB {
    INTRO,
    CHALLENGES,
    TOURNAMENTS,
    SHOP,
    INBOX,
    COMPLETED,
}

export enum TournamentType {
    ONGOING,
    UPCOMING,
    COMPLETED,
}
